import { useCachedDevices } from '@/auth/devices';
import { useAuth } from '@/auth/store';
import { isThisDevice } from '@/auth/thisDevice';
import type { TimerApi } from '@/timer/useTimer';

/**
 * "Running on MacBook · Chrome" on a device that did not start the run (architecture §5.2). The clock is identical
 * everywhere; this line explains where the chime will sound.
 */
export function RunningElsewhere({ api }: { api: TimerApi }) {
  const { timer } = api;
  const myDeviceId = useAuth((s) => s.deviceId);
  const devices = useCachedDevices();
  // Signed out there is no other device to be running on; signed in, either of this browser's ids means "here".
  if (timer.status === 'idle' || !timer.startedOnDeviceId || !myDeviceId || isThisDevice(timer.startedOnDeviceId, myDeviceId)) return null;
  const label = devices.find((d) => d.id === timer.startedOnDeviceId)?.label ?? 'another device';
  return <p className="text-meta-sm text-ink-2 m-0">Running on {label}</p>;
}
